import { cardFaceNames } from '../../utils/cardFaces'

/** A card name, with the second part of "A // B" on a quieter line so long names stay readable. */
export default function CardName({ name }: { name: string }) {
  const [front, back] = cardFaceNames(name)
  if (back === undefined) return <>{name}</>
  return (
    <>
      {front}
      <span style={{ display: 'block', fontSize: '0.85em', fontWeight: 400, opacity: 0.7 }}>{`// ${back}`}</span>
    </>
  )
}
